import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import getPageLocalesData, { getLocalesForHtml } from '@src/global-locales/get-page-locales-data';
import CookieSettingModal from '@src/components/cookie-modal/cookie-setting-modal';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import Config from '@src/pages/main/components/footer/config';
import styles from './index.less';
import CookieTipsModalStore from './store';

const lang = getLanguageByPath();

const pageLocalesData = getPageLocalesData();
const cookieInfo = pageLocalesData.cookieInfo;

/**
 * CookieTipsModal
 * @param store {CookieTipsModalStore}
 * @param onClose
 * @returns {JSX.Element}
 * @constructor
 */
const CookieTipsModal = ({ store, onClose }) => {
  store.use();
  store.onClose = onClose;
  const renderContainer = () => {
    if (store.showCookieSettings) {
      return <CookieSettingModal store={store.cookieSettingModalStore} onClose={store.onCookieSettingModalClose} />;
    } else {
      return (
        <div className={cx(styles.container, 'cookie-tips-modal-root')}>
          <div className={styles.closeBtn} onClick={store.onClose} />
          <div className={cx(styles.cookieSettingDesc)}>{getLocalesForHtml('cookieInfo.cookie_description', { link: Config[lang].cookie })}</div>
          <div className={styles.btnGroup}>
            <div className={cx(styles.btn)} onClick={store.onCookieSettingShowClick}>
              {cookieInfo.cookie_setting_btn}
            </div>
            <div className={cx(styles.btn)} onClick={store.rejectOptionalCookies}>
              {cookieInfo.reject_all_cookies}
            </div>
            <div className={cx(styles.btn)} onClick={store.acceptOptionalCookies}>
              {cookieInfo.allow_all_cookies}
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <ModalContainer modalState={store.isShow}>
      <div className={cx(styles.root)} ref={store.rootRef}>
        {renderContainer()}
      </div>
    </ModalContainer>
  );
};

export default wrapStore(CookieTipsModal, CookieTipsModalStore);
